import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import StorePauseBanner from './StorePauseBanner';
import Footer from './Footer';
import CartDrawer from '../ui/CartDrawer';
import ToastContainer from '../ui/Toast';

export default function Layout() {
  return (
    <div className="site-wrapper">
      <Navbar />
      <StorePauseBanner />
      <main>
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <ToastContainer />
    </div>
  );
}